<template>
  <button
    type="button"
    class="btn btn-sm btn-outline-info"
    @click="open"
  >
    <i class="fa fa-search mr-1"></i>
    Detalhes
    <span v-if="fullLabel">do item</span>
  </button>
</template>

<script>
export default {
  name: 'item-details-button',

  props: {
    itemId: {
      type: [String, Number],
      required: true
    },

    fullLabel: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    open() {
      this.$root.$emit('open-item-details', this.itemId);
    }
  }
}
</script>
